import React from 'react';
import { PhoneIncoming, PhoneOutgoing, PhoneCall } from 'lucide-react';
import Badge, { type BadgeSize } from './Badge';
import { direction as directionDict } from '@/lib/dict';
import type { Direction } from '@/lib/api/types';

/** Направление звонка: inbound, outbound, internal — закрытый список. */

/** Цвета для сжатого вида: бейджа нет, кружок рисуется сам. */
const toneRing: Record<string, string> = {
  info: 'bg-blue-50 text-blue-700 border border-blue-200',
  neutral: 'bg-slate-100 text-slate-700 border border-slate-200',
  muted: 'bg-slate-50 text-slate-500 border border-slate-200',
  success: 'bg-green-50 text-green-700 border border-green-200',
  warning: 'bg-amber-50 text-amber-700 border border-amber-200',
  danger: 'bg-red-50 text-red-700 border border-red-200',
};

const icons: Record<Direction, React.ReactNode> = {
  inbound: <PhoneIncoming size={10} />,
  outbound: <PhoneOutgoing size={10} />,
  internal: <PhoneCall size={10} />,
};

export default function CallTypeBadge({
  type,
  size = 'md',
  compact = false,
}: {
  type: Direction;
  size?: BadgeSize;
  /**
   * Только стрелка, без слова. Направление различимо по иконке, а в узкой
   * таблице слово «Внутренний» занимает больше места, чем несёт смысла;
   * подпись остаётся во всплывающей подсказке.
   */
  compact?: boolean;
}) {
  const term = directionDict[type] ?? { label: type, tone: 'muted' as const };

  if (compact) {
    return (
      <span
        title={term.label}
        aria-label={term.label}
        className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${toneRing[term.tone]}`}
      >
        {icons[type]}
      </span>
    );
  }

  return (
    <Badge tone={term.tone} size={size} icon={icons[type]}>
      {term.label}
    </Badge>
  );
}
